export default "__VITE_ASSET__ClNsGO3L__ 700w";